import React from 'react';
import successSVG from 'client/v3/icons/success.svg';
import Image from '@ff/ui/Image';
import Text from '@ff/ui/Text';
import { styled } from '@ff/ui';
import FlexCol from '@ff/ui/FlexCol';
import Button from '@ff/ui/Button';
import appHandlers from 'client/utils/appHandlers';
import useConfig from 'client/hooks/useConfig';
import url from 'client/utils/url';
import PATHS from 'client/utils/paths';
import ga_ids from 'client/ga_ids';
import { useParams } from 'react-router-dom';


export default function SuccessPaymentPage() {
  const config = useConfig();
  const isApp = config.APPONLY === '1';
  const { successType } = useParams();

  const isPaymentSuccess = successType === 'success-payment';
  const isUpdateSuccess = successType === 'update-success';

  let id: string | undefined;

  if (isUpdateSuccess) {
    id = ga_ids.preorder_update_success;
  } else if (isPaymentSuccess) {
    id = ga_ids.preorder_success;
  }

  const handleGoToMyVehicleCollection = () => {
    if (isApp) {
      setTimeout(appHandlers.getHandlerByKey('OpenVehicleCollection'), 10);
    } else {
      window.location.href = url.getSameRegionPath(`${PATHS.MY_FF}`);
    }
  }

  return (
    <Container id={id}>
      <Image src={successSVG} />
      {isPaymentSuccess && <Text>Successful payment</Text>}
      {isUpdateSuccess && <Text>Successful update</Text>}
      <Button variant='primary' onClick={handleGoToMyVehicleCollection}>Go to My Vehicle Collection</Button>
    </Container>
  );
}

const Container = styled(FlexCol)({
  alignItems: 'center',
  justifyContent: 'center',
  gap: '30px',
  height: '80vh'
});
